export const fetchPolicyCard = async (selectedAreaIds) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v2/policy_card`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ policyAreaIds: selectedAreaIds }),
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
